var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pick_share"},[_c('button',{staticClass:"btn",on:{"click":_vm.touchMember}},[_vm._v("分享给客户")]),_c('button',{staticClass:"btn",on:{"click":_vm.touchDesigner}},[_vm._v("分享给家装设计师")])])
}
var staticRenderFns = []

export { render, staticRenderFns }